<template>
    <div class="card-container">
        <div class="card">
            <img src="@/assets/images/home/ourservices/img1.webp">
            <div class="card-body">{{ $t('home.our_services.service_1') }} </div>
        </div>

        <div class="card">
            <img src="@/assets/images/home/ourservices/img2.webp">
            <div class="card-body"> {{ $t('home.our_services.service_2') }}</div>

        </div>

        <div class="card">
            <img src="@/assets/images/home/ourservices/img3.webp">
            <div class="card-body">{{ $t('home.our_services.service_3') }}</div>
        </div>

        <div class="card">
            <img src="@/assets/images/home/ourservices/img4.webp">
            <div class="card-body"> {{ $t('home.our_services.service_4') }}</div>
        </div>

        <div class="card">
            <img src="@/assets/images/home/ourservices/img5.webp">
            <div class="card-body"> {{ $t('home.our_services.service_5') }}</div>
        </div>
    </div>

</template>

<style scoped>
.card-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}

.card {
    flex: 1 1 18%;
    /* Adjust for 5 cards per row */
    max-width: 18%;
    /* Ensures consistency */
    border: none;
    overflow: hidden;
    border-radius: 10px;
    height: 294px;
    margin-bottom: 4px;
}

.card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 10px;
}

.card-body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    color: white;
    text-align: center;
    padding: 10px;
    font-size: 1rem;
    font-weight: bold;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    font-size: 24px;
    font-weight: 500;
}

@media (max-width: 992px) {

    /* Medium screens */
    .card {
        flex: 1 1 30%;
        /* 3 per row */
        max-width: 30%;
    }
}

@media (max-width: 768px) {

    /* Small screens */
    .card {
        flex: 1 1 48%;
        /* 2 per row */
        max-width: 48%;
    }
}

@media (max-width: 576px) {

    /* Extra Small screens */
    .card {
        flex: 1 1 100%;
        /* 1 per row */
        max-width: 100%;
    }
}
</style>